import { render, staticRenderFns } from "./successBuyModal.vue?vue&type=template&id=1386f038&scoped=true"
import script from "./successBuyModal.vue?vue&type=script&lang=js"
export * from "./successBuyModal.vue?vue&type=script&lang=js"
import style0 from "./successBuyModal.vue?vue&type=style&index=0&id=1386f038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386f038",
  null
  
)

export default component.exports